import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function SideNav() {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Hamburger knop */}
      <button
        className="sidenav-toggle"
        onClick={() => setOpen(true)}
        aria-label="Menu openen"
      >
        <span /><span /><span />
      </button>

      {/* Overlay */}
      {open && (
        <div
          className="sidenav-overlay"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Drawer */}
      <nav className={`sidenav-drawer ${open ? "sidenav-drawer--open" : ""}`}>
        <button
          className="sidenav-close"
          onClick={() => setOpen(false)}
          aria-label="Menu sluiten"
        >
          ✕
        </button>

        <div className="sidenav-logo-wrapper">
          <img
            src={process.env.PUBLIC_URL + "/datavolwassenheid.png"}
            alt="Datavolwassenheid.nl"
            className="sidenav-logo"
          />
        </div>

        <hr className="sidenav-divider" />

        <div className="sidenav-top">
          <Link
            to="/"
            className="login-btn"
            onClick={() => setOpen(false)}
          >
            Mijn Boardroom
          </Link>
        </div>

        <div className="sidenav-bottom">
          <a
            href="/.auth/logout?post_logout_redirect_uri=/login"
            className="login-btn sidenav-logout"
          >
            Uitloggen
          </a>
        </div>
      </nav>
    </>
  );
}
